module.exports = __webpack_public_path__ + "ad4a5b17bf04c2890ec2301d97b2f834.png";